var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInactiveIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 21,
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/mobile"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M15.4 6V15C15.4 18.6 14.5 19.5 10.9 19.5H5.5C1.9 19.5 1 18.6 1 15V6C1 2.4 1.9 1.5 5.5 1.5H10.9C14.5 1.5 15.4 2.4 15.4 6Z",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.0004 4.65039H6.40039",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.19969 16.8896C8.97012 16.8896 9.59469 16.265 9.59469 15.4946C9.59469 14.7242 8.97012 14.0996 8.19969 14.0996C7.42925 14.0996 6.80469 14.7242 6.80469 15.4946C6.80469 16.265 7.42925 16.8896 8.19969 16.8896Z",
    stroke: "#FF852D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInactiveIcon);
export default __webpack_public_path__ + "static/media/inactive-icon.15df8f3893c75d99586349585b2df527.svg";
export { ForwardRef as ReactComponent };